import { StylesConfig } from "react-select";

export const selectTheme: StylesConfig<any, boolean, any> | undefined = {
  singleValue: (base: any) => ({ ...base, color: "white" }),
  valueContainer: (base: any) => ({
    ...base,
    width: "100%",
  }),
  control: (base: any, state: any) => ({
    ...base,
    background: "#1f2937",
    border: "1px solid #6b7280",
    color: "#000",
  }),
  menu: (base: any, props: any) => ({
    ...base,
    zIndex: 999999999,
    background: "#1f2937",
  }),
};
